import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Spinner,
  Table,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { FiCheck, FiX } from "react-icons/fi";
import Link from "next/link";
import Head from "next/head";

//local imports
import Hero from "../generic/hero";
import classes from "@/styles/pricing/pricing.module.css";
import { pricing } from "@/utils/content";
import { routes } from "@/utils/routes";
import pricingData from "@/data/pricing.json";
import useAlertBar from "@/hooks/useAlertBar";
import { getPricingPlans } from "@/services/pricing";
import { useIsMobile } from "@/hooks/useIsMobile";

let featureNames = [
  "Shipments per Month",
  "Link Your Own Courier Accounts",
  "Available Users",
];

export default function PricingMain() {
  const content = pricing.en;

  const isMobile = useIsMobile();
  const { openAlertBar } = useAlertBar();
  const [tab, setTab] = useState("monthly");

  const [freePlan, setFreePlan] = useState<any>({});

  const [open, setOpen] = useState("1");
  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const [open2, setOpen2] = useState("1");
  //@ts-ignore
  const toggle2 = (id) => {
    if (open2 === id) {
      //@ts-ignore
      setOpen2();
    } else {
      setOpen2(id);
    }
  };

  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data } = await getPricingPlans();
      if (data.status) {
        // Swapping items in array because Starter plan needs to appear first
        [data.data[0], data.data[1]] = [data.data[1], data.data[0]];
        setData(data);
        setFreePlan(data.data.find((p: any) => p.title === "Starter"));
      } else {
        openAlertBar(data.message, false);
      }
      setIsLoading(false);
    } catch (error) {
      openAlertBar(
        "Unexpected error occurred while fetching plans. Please try again later",
        false
      );
      setIsLoading(false);
      console.log(error);
    }
  };

  const getNonDiscountedPrice = (title: string) => {
    if (tab === "yearly") {
      if (title == "Professional") {
        return 359.88;
      } else if (title == "Enterprise") {
        return 839.88;
      }
    } else {
      if (title == "Professional") {
        return 29.99;
      } else if (title == "Enterprise") {
        return 69.99;
      }
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.container}>
      {isLoading ? (
        <div className="p-5 d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        data.data && (
          <div className="container mt-5">
            <section>
              <h1 className="text-center fw-bold">{content.title}</h1>
              <p className="text-center w-50 mx-auto">{content.para}</p>
            </section>
            <section className="text-center mt-5">
              <Button
                className={
                  tab === "yearly"
                    ? classes.btnActiveLeft
                    : classes.btnInActiveLeft
                }
                onClick={() => setTab("yearly")}
              >
                {content.yearly}
              </Button>
              <Button
                className={
                  tab === "monthly"
                    ? classes.btnActiveRight
                    : classes.btnInActiveRight
                }
                onClick={() => setTab("monthly")}
              >
                {content.monthly}
              </Button>
              <Row className="mt-5">
                <Col className="pt-4" xs={12} lg={2}>
                  {/* free plan */}
                  {freePlan && (
                    <Card className={`${classes.freeCard} mt-5 mb-5`}>
                      <CardHeader className={classes.freeCardHeader}>
                        {content.alwaysFree}
                      </CardHeader>
                      <CardBody className="text-center">
                        <h3 className={classes.cardTitle}>{freePlan.title}</h3>
                        <p className={classes.cardPara}>
                          {freePlan.description}
                        </p>
                        <h1 className={classes.cardPrice}>FREE</h1>
                        <ul className={`${classes.ul} text-start`}>
                          {freePlan.features
                            ?.filter((f: any) =>
                              featureNames.includes(f.featureName)
                            )
                            .sort((a: any, b: any) =>
                              (b.featureName as string).localeCompare(
                                a.featureName as string
                              )
                            )
                            .map((feature: any, i: any) => {
                              const { featureName, featureValue } = feature;
                              let content = "";
                              switch (featureName) {
                                case featureNames[0]:
                                  content += `${
                                    featureValue ? featureValue : ""
                                  } ${
                                    freePlan.title === "Starter"
                                      ? "Shipments"
                                      : ""
                                  }`;
                                  break;
                                case featureNames[1]:
                                  content += `${
                                    featureValue === "Yes"
                                      ? "Unlimited Carrier Accounts"
                                      : "Using Shipvista Accounts Only"
                                  }`;
                                  break;
                                case featureNames[2]:
                                  content += `${featureValue} User(s)`;
                                  break;
                              }
                              return (
                                <li key={featureName} className={classes.li}>
                                  {content}
                                </li>
                              );
                            })}
                        </ul>
                        <Link
                          className={`btn btn-lg ${classes.cardBtn}`}
                          href={`/pricing/${freePlan.title
                            ?.replace(" ", "-")
                            .toLowerCase()}`}
                        >
                          {content.signUp}
                        </Link>
                      </CardBody>
                    </Card>
                  )}
                  {/*  */}
                </Col>
                <Col xs={12} lg={10}>
                  <Card className={classes.cardBig}>
                    <CardHeader className={classes.cardBigHeader}>
                      {content.paid}
                    </CardHeader>
                    <CardBody>
                      <Row>
                        {data.data?.map((p: any, i: number) => {
                          if (p.title !== "Starter")
                            return (
                              <Col xs={12} lg={3} key={i}>
                                <Card
                                  className={
                                    p.title === "Professional"
                                      ? `${classes.recommendedCard} mt-1`
                                      : "mt-5"
                                  }
                                >
                                  {p.title === "Professional" && (
                                    <CardHeader
                                      className={classes.RecommendedCardHeader}
                                    >
                                      {content.recommended}
                                    </CardHeader>
                                  )}
                                  <CardBody className="text-center">
                                    <h3 className={classes.cardTitle}>
                                      {p.title}
                                    </h3>
                                    <p className={classes.cardPara}>
                                      {p.description}
                                    </p>
                                    <p className={classes.cardPriceDiscount}>
                                      {p.title !== "Beta Associate" ? (
                                        <>
                                          {p.price.currency} $
                                          {getNonDiscountedPrice(p.title)}
                                          <span className={classes.period}>
                                            &nbsp;/
                                            {tab === "yearly" ? "yr." : "mo."}
                                          </span>
                                        </>
                                      ) : (
                                        <br />
                                      )}
                                    </p>
                                    <h1
                                      className={
                                        p.title === "Beta Associate"
                                          ? classes.cardPrice
                                          : classes.cardPriceDe
                                      }
                                    >
                                      {p.price.currency} $
                                      {tab === "monthly"
                                        ? p.price.amount
                                        : p.yearlyprice}
                                      /{tab === "yearly" ? "yr." : "mo."}
                                    </h1>
                                    <ul className={`${classes.ul} text-start`}>
                                      {p.features
                                        ?.filter((f: any) =>
                                          featureNames.includes(f.featureName)
                                        )
                                        .sort((a: any, b: any) =>
                                          (
                                            b.featureName as string
                                          ).localeCompare(
                                            a.featureName as string
                                          )
                                        )
                                        .map((feature: any, i: any) => {
                                          const { featureName, featureValue } =
                                            feature;
                                          let content = "";
                                          switch (featureName) {
                                            case featureNames[0]:
                                              content += `${
                                                featureValue ? featureValue : ""
                                              } ${
                                                p.title === "Starter"
                                                  ? "Shipments"
                                                  : ""
                                              }`;
                                              break;
                                            case featureNames[1]:
                                              content += `${
                                                featureValue === "Yes"
                                                  ? "Unlimited Carrier Accounts"
                                                  : "Using Shipvista Accounts Only"
                                              }`;
                                              break;
                                            case featureNames[2]:
                                              content += `${featureValue} User(s)`;
                                              break;
                                          }
                                          return (
                                            <li
                                              key={featureName}
                                              className={classes.li}
                                            >
                                              {content}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                    <Link
                                      className={`btn btn-lg ${classes.cardBtn}`}
                                      href={`/pricing/${p.title
                                        .replace(" ", "-")
                                        .toLowerCase()}`}
                                    >
                                      {content.signUp}
                                    </Link>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                        })}
                        <Col xs={12} lg={3}>
                          <Card className={`mt-5`}>
                            <CardBody className="text-center">
                              <h3 className={classes.cardTitle}>
                                {content.customizable}
                              </h3>
                              <p className={classes.cardPara}>
                                {content.custDesc}
                              </p>
                              <h5 className={classes.cardContactUs}>
                                {content.contactUs}
                              </h5>
                              <ul className={`${classes.ul} text-start`}>
                                {content.custFeatures.map((f, i) => {
                                  return (
                                    <li key={i} className={classes.li}>
                                      {f}
                                    </li>
                                  );
                                })}
                              </ul>
                              <Link
                                className={`btn btn-lg ${classes.cardBtn}`}
                                href={routes.contact}
                              >
                                {content.contactWithUs}
                              </Link>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <p className="text-center mt-3">{content.para2}</p>
            </section>
            <section className={`my-5`}>
              <h4 className="text-center fw-bold mb-4">
                {content.coreFeatures}
              </h4>
              <div
                className={`${
                  isMobile ? "" : "w-75 mx-auto border border-2 rounded"
                } `}
              >
                <Table
                  responsive
                  className={`${classes.table} ${
                    isMobile ? "table-bordered" : ""
                  }`}
                  striped
                >
                  <thead>
                    <tr>
                      <th>Features</th>
                      {data.data?.map((p: any, i: number) => {
                        return (
                          <th className="text-center" key={i}>
                            {p.title}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {data.data[0].features.map((f: any, i: number) => {
                      if (f.featureCategory === "CORE")
                        return (
                          <tr key={i}>
                            <td className="w-25">{f.featureName}</td>
                            {data.data.map((p: any, i: number) => {
                              const fea = p.features.find(
                                (ff: any) => ff.featureName === f.featureName
                              );
                              return (
                                <td
                                  key={i}
                                  className={`text-center ${classes.td}`}
                                >
                                  {fea.featureValue === "Yes" ? (
                                    <FiCheck className={classes.yes} />
                                  ) : fea.featureValue === "No" ? (
                                    <FiX className={classes.no} />
                                  ) : (
                                    fea.featureValue
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                    })}
                  </tbody>
                </Table>
              </div>
            </section>
            <section className={`my-5`}>
              <h4 className="text-center fw-bold mb-4">
                {content.advanceFeatures}
              </h4>
              <div
                className={`${
                  isMobile ? "" : "w-75 mx-auto border border-2 rounded"
                } `}
              >
                <Table
                  responsive
                  className={`${classes.table} ${
                    isMobile ? "table-bordered" : ""
                  }`}
                  striped
                >
                  <thead>
                    <tr>
                      <th>Features</th>
                      {data.data.map((p: any, i: number) => {
                        return (
                          <th className="text-center" key={i}>
                            {p.title}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {data.data[0]?.features.map((f: any, i: number) => {
                      if (f.featureCategory === "ADVANCED")
                        return (
                          <tr key={i}>
                            <td className="w-25">{f.featureName}</td>
                            {data.data.map((p: any, i: number) => {
                              const fea = p.features.find(
                                (ff: any) => ff.featureName === f.featureName
                              );
                              return (
                                <td
                                  key={i}
                                  className={`text-center ${classes.td}`}
                                >
                                  {fea.featureValue === "Yes" ? (
                                    <FiCheck className={classes.yes} />
                                  ) : fea.featureValue === "No" ? (
                                    <FiX className={classes.no} />
                                  ) : (
                                    fea.featureValue
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                    })}
                  </tbody>
                </Table>
              </div>
            </section>
            <section className="my-5 pt-5 pb-5">
              <Row>
                <Col xs={12} lg={3}>
                  <h3>{content.faq}</h3>
                  <p>{content.faqPara}</p>
                </Col>
                <Col xs={12} lg={9}>
                  <Accordion
                    open={open}
                    //@ts-ignore
                    toggle={toggle}
                  >
                    {pricingData.faq?.map((faq, i) => {
                      return (
                        <AccordionItem key={i}>
                          <AccordionHeader targetId={(i + 1).toString()}>
                            {faq.name}
                          </AccordionHeader>
                          <AccordionBody accordionId={(i + 1).toString()}>
                            {faq.desc}
                          </AccordionBody>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </Col>
              </Row>
            </section>
            <section className="my-5">
              <h3 className="text-center">{content.faqPricing}</h3>
              <p className="text-center mb-5">
                {content.faqPara2}&nbsp;
                <Link href={content.email}>{content.reachOut}</Link>
              </p>
              <Row>
                <Col xs={12} lg={6}>
                  <Accordion
                    open={open}
                    //@ts-ignore
                    toggle={toggle}
                  >
                    {pricingData.faqPricing?.map((faq, i) => {
                      if (i < 7)
                        return (
                          <AccordionItem key={i}>
                            <AccordionHeader targetId={(i + 1).toString()}>
                              {faq.name}
                            </AccordionHeader>
                            <AccordionBody accordionId={(i + 1).toString()}>
                              {faq.desc}
                            </AccordionBody>
                          </AccordionItem>
                        );
                    })}
                  </Accordion>
                </Col>
                <Col xs={12} lg={6}>
                  <Accordion
                    open={open}
                    //@ts-ignore
                    toggle={toggle}
                  >
                    {pricingData.faqPricing?.map((faq, i) => {
                      if (i >= 7)
                        return (
                          <AccordionItem key={i}>
                            <AccordionHeader targetId={(i + 1).toString()}>
                              {faq.name}
                            </AccordionHeader>
                            <AccordionBody accordionId={(i + 1).toString()}>
                              {faq.desc}
                            </AccordionBody>
                          </AccordionItem>
                        );
                    })}
                  </Accordion>
                </Col>
              </Row>
            </section>
          </div>
        )
      )}
    </div>
  );
}
